import React, { useState, useEffect } from "react";
import { Card, Button, Input, Divider, List, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { api } from "../../../../services/api";

const { TextArea } = Input;

const CommentsCard = ({ commentsData, issue, user }: any) => {
  const [comments, setComments] = useState<any[]>([]);
  const [newComment, setNewComment] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (Array.isArray(commentsData)) {
      setComments(commentsData);
    }
  }, [commentsData]);

  const handleAddComment = async () => {
    if (newComment.trim()) {
      const newCommentObj = {
        remarks: newComment,
      };

      setLoading(true);
      try {
        const response = await api.addComment(issue.id, newCommentObj);
        console.log("🚀 ~ Comment ~ response:", response);

        const objToSave = {
          remarks: newComment,
          // updated_by: "670906394581303855b5170e",
          updated_at: new Date().toISOString(),
        };

        setComments((prevComments) => [objToSave, ...prevComments]);
        setNewComment("");
      } catch (error) {
        console.error("Error adding comment:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Card title="Comments" style={{ marginTop: 16 }}>
      <TextArea
        value={newComment}
        onChange={(e) => setNewComment(e.target.value)}
        placeholder="Add a comment..."
        rows={3}
        disabled={loading}
      />
      <Button
        type="primary"
        icon={<PlusOutlined />}
        style={{ marginTop: 8 }}
        onClick={handleAddComment}
        loading={loading}
        disabled={!newComment.trim() || loading}
      >
        {loading ? "Adding..." : "Add Comment"}
      </Button>
      <Divider />

      <List
        dataSource={comments}
        renderItem={(comment: any) => (
          <List.Item key={comment.id}>
            <div style={{ width: "100%" }}>
              <Typography.Text strong>
                {user[comment.updated_by]?.name || "You"}
              </Typography.Text>
              <Typography.Paragraph style={{ margin: "4px 0" }}>
                {comment.remarks}
              </Typography.Paragraph>
              <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                {new Date(comment.updated_at).toLocaleString()}
              </Typography.Text>
            </div>
          </List.Item>
        )}
      />
    </Card>
  );
};

export default CommentsCard;
